var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseApi } from '../baseApi';
export default class ContractsApi extends BaseApi {
    constructor() {
        super(...arguments);
        this.apiBasePath = 'contracts';
    }
    getContracts(params_1) {
        return __awaiter(this, arguments, void 0, function* (params, options = {}) {
            var _a, _b, _c, _d;
            const _params = Object.assign(Object.assign({}, params), { id: (_b = (_a = params === null || params === void 0 ? void 0 : params.id) === null || _a === void 0 ? void 0 : _a.join(',')) !== null && _b !== void 0 ? _b : undefined, customerId: (_d = (_c = params === null || params === void 0 ? void 0 : params.customerId) === null || _c === void 0 ? void 0 : _c.join(',')) !== null && _d !== void 0 ? _d : undefined });
            return yield this.apiCall(Object.assign({ method: 'GET', route: `v2/${this.apiBasePath}`, params: _params }, options));
        });
    }
    legacyGetContracts(params_1) {
        return __awaiter(this, arguments, void 0, function* (params, options = {}) {
            var _a, _b, _c, _d;
            const _params = Object.assign(Object.assign({}, params), { id: (_b = (_a = params === null || params === void 0 ? void 0 : params.id) === null || _a === void 0 ? void 0 : _a.join(',')) !== null && _b !== void 0 ? _b : undefined, customerId: (_d = (_c = params === null || params === void 0 ? void 0 : params.customerId) === null || _c === void 0 ? void 0 : _c.join(',')) !== null && _d !== void 0 ? _d : undefined });
            return yield this.apiCall(Object.assign({ method: 'GET', route: 'contracts', params: _params }, options));
        });
    }
    createContract(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'POST',
                route: `${this.apiBasePath}`,
                data,
            });
        });
    }
    createOtherFee(contractId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'POST',
                route: `${this.apiBasePath}/${contractId}/other-fees`,
                data,
            });
        });
    }
    updateContract(id, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'PUT',
                route: `${this.apiBasePath}`,
                params: {
                    id: id,
                },
                data,
            });
        });
    }
    deleteContract(id_1) {
        return __awaiter(this, arguments, void 0, function* (id, softDelete = true) {
            return yield this.apiCall({
                method: 'DELETE',
                route: `${this.apiBasePath}`,
                params: {
                    id: id,
                    softDelete: softDelete,
                },
            });
        });
    }
}
//# sourceMappingURL=index.js.map